export default "__VITE_ASSET__vaEAQGF___"